export const DigitalSection = () => {
  const digitalItems = [
    {
      title: 'Pre-event awareness',
      description:
        'Run ads ahead of a conference to let local clinicians know your team will be present ',
      number: '01',
    },
    {
      title: 'Live geofencing',
      description:
        'Digitally tag devices at the event venue for real-time and post-event targeting ',
      number: '02',
    },
    {
      title: 'Follow-up visibility',
      description:
        'Keep your brand top of mind for 30+ days post-conference with relevant content or open roles ',
      number: '03',
    },
    {
      title: 'Lead capture',
      description:
        'Receive a full list of attendees who viewed or clicked, including contact and specialty info ',
      number: '04',
    },
  ];

  const DigitalBox = ({ title, description, number }) => {
    return (
      <div
        style={{
          boxShadow: '0px 4px 20px -2px #32324714, 0px 0px 1px 0px #0C1A4B1A',
        }}
        className="bg-[#FFFFFF] max-w-[600px] p-[10px] rounded-[14px] flex flex-col lg:flex-row gap-[20px] mx-[10px] lg:mx-0"
      >
        <div className="w-[32px] h-[32px] text-[12px] lg:text-[14px] lg:w-[48px] lg:h-[48px] rounded-full bg-[#2F72BD] text-white flex items-center justify-center">
          {number}
        </div>
        <div className="max-w-[470px]">
          <h3 className="text-[24px] font-bold">{title}</h3>
          <p className="text-[18px]">{description}</p>
        </div>
      </div>
    );
  };

  return (
    <div className="bg-[#DBECFF] py-[40px] lg:py-[80px] my-[40px] lg:my-[80px] max-w-[1280px] mx-[5%] lg:mx-auto rounded-[40px]">
      <h1 className="text-[30px] lg:text-[50px] font-bold text-center">
        Enhancing Conferences, Events and Referral Pipelines with Digital 
      </h1>
      <p className="text-[18px] text-center">
        NPI-targeted campaigns also help reinforce offline efforts. Whether
        you're attending conferences <br /> or relying on referrals, you can
        extend those efforts with:
      </p>

      <div className="flex justify-center gap-[25px] flex-wrap">
        {digitalItems.map((item) => (
          <DigitalBox
            title={item.title}
            description={item.description}
            number={item.number}
          />
        ))}
      </div>
    </div>
  );
};
